
import { computed } from 'vue'
import { defineComponent, onBeforeMount, PropType } from 'vue'

const TABS = [
    { id: 'general', name: 'Основная информация' },
    { id: 'cargo', name: 'Информация о грузе', isIntracity: true },
    { id: 'payment', name: 'Оплата' },
    { id: 'sender-and-stops', name: 'Отправитель / Остановки' },
]

export default defineComponent({
    props: {
        value: {
            type: String,
            default: null,
        },
        files: {
            type: Array as PropType<File[]>,
            default: () => [],
        },
        isIntracity: {
            type: Boolean,
            default: false,
        },
        isNeedCar: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const isTabSelected = (tab: { id: string }) => {
            if (!props.value) return false
            return props.value === tab.id
        }

        const selectTab = (tab: { id: string }) => {
            if (isTabSelected(tab)) return
            emit('update:value', tab.id)
            emit('change', tab.id)
        }

        const setTabs = () => {
            const filesTab = TABS.find((tab) => tab.id === 'files')
            const vehicleTab = TABS.find((tab) => tab.id === 'vehicle-information')

            if (props.files.length && !filesTab) {
                TABS.push({ id: 'files', name: 'Файлы' })
            }
            if (!vehicleTab && props.isNeedCar) {
                TABS.push({ id: 'vehicle-information', name: 'Информация о машине' })
            }
        }

        const getTabs = computed(() => {
            if (props.isIntracity) {
                return TABS
            }
            return TABS.filter((tab) => !tab.isIntracity)
        })

        onBeforeMount(setTabs)

        return {
            getTabs,
            isTabSelected,
            selectTab,
        }
    },
})
